// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".declarations[data-v-3ef232fe]{list-style:none;padding-left:0;padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
